import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../App.css';
import Dashheader from '../Dash-header/Dashheader';
import Sidebar from '../dashboard/Sidebar';
import './privacy.css';
import UserFooter from '../footer/UserFooter.jsx';

import { END_URL, IMG_URL } from "../../config.js";



function PrivacyPolicy({isLoggedIn}) {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${END_URL}page`);
        setHome(response.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {

      if (!home?.privacy) return;

      const container = document.querySelector(".privacy-content");
      if (!container) return;

      const links = container.querySelectorAll("ol li a");

      const handleScroll = (e, targetTitle) => {
        e.preventDefault();

        const headings = container.querySelectorAll("h2");

        const target = Array.from(headings).find((h2) => {
          const text = h2.innerText.replace(/^\d+\.\s*/, "").trim().toLowerCase();
          return text === targetTitle.toLowerCase();
        });

        if (target) {
            const offset = 100; 
            const targetPosition =
              target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
              top: targetPosition,
              behavior: "smooth",
            });
          }
      };

      links.forEach((link) => {
        const title = link.textContent.trim();
        link.addEventListener("click", (e) => handleScroll(e, title));
      });
      return () => {
        links.forEach((link) => {
          const title = link.textContent.trim();
          link.removeEventListener("click", (e) => handleScroll(e, title));
        });
      };
    }, [home?.privacy]);

    const [expanded1, setExpanded] = useState(false);

  return (
    <div className={`dashboard-container ${isLoggedIn ? '' : 'allow-full-width'}`}>

      <Dashheader />

      <div className="container">
        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>

        {isLoggedIn && (

          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>
        )}
   
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <main className="content">
              <div className="dashbord-first">
                <h3>Privacy Policy</h3>
                <p>Your privacy is important to us. This policy outlines how we handle your information.</p>
              </div>
              <div className="privacy-policy-content">

                {home ? (
                  <div className="privacy-content" dangerouslySetInnerHTML={{ __html: home?.privacy }} />
                ) : (
                  <p>Loading Privacy Policy...</p>
                )}

              </div>

              {isLoggedIn && (

                <UserFooter />

              )}

            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
